export class NormalizedError extends Error {}
